<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :module_name="page.name" :current="record.name"/>
    <v-row>
      <v-col>
        <base-profile
            :save_loading="loading"
            :module_name="page.name"
            :record="record"
            @change="save"
            @archive="archive"
            :user_type="page.model">
          <template v-slot:below_photo>
            <v-row>
              <v-col v-if="record.person && !record.person.user" class="text-center">
                <base-create-user
                  :person_id="record.person.id"
                  :user_type="page.model"
                  :emailaddress="getEmailaddress"
                  :person="record.person"
                  @refresh="load"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="record.person && record.person.user" class="text-center">
                <base-notification
                  @refresh="load"
                  :user_id="record.person.user.id"
                  :recipient="record.person.name"
                  :phonenumber="record.person.mobilenumber"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="record.person && record.person.user" class="text-center">
                <v-btn @click="resetPassword" :loading="reset_password_loading" small>
                  {{ $store.getters.translate("reset_your_password") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="record.person && record.person.user" class="text-center">
                <v-btn @click="deleteUser" :loading="reset_delete_user_loading" small color="error">
                  {{ $store.getters.translate("delete_account") }}
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <v-footer-panel ref="footer_panel" slot="footer" :model="page.name"/>
        </base-profile>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-expansion-panels v-model="panel" multiple>
          <base-table-includable ref="roles_table" :page="page" :parent_module_id="user_id" relation_name="roles" @edit="editRole" @change="load"/>
          <base-table-includable ref="tokens_table" :page="page" :parent_module_id="user_id" relation_name="tokens" @create="createToken" @edit="editToken" @change="load"/>
          <base-table-includable ref="notes_table" :page="page" :parent_module_id="record.id" relation_name="notes" @create="createNote" @edit="editNote" @change="load"/>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <edit-note modal_name="edit_note" :module_name="page.name" :model_id="record.id" ref="edit_note" @document_preview="preview" @refresh="load" :model_type="$models[page.name]"/>
    <create-note modal_name="create_note" :module_name="page.name" :model_id="record.id" ref="create_note" @refresh="load"/>
    <create-token modal_name="create_token" ref="create_token" @refresh="load"/>
    <edit-token modal_name="edit_token" ref="edit_token" @refresh="load"/>
    <document-edit modal_name="document_edit" ref="document_edit"/>
  </v-container>
</template>

<script>
import BaseTableIncludable from "../../components/commonComponents/BaseTableIncludableData";
import BaseProfile from "../../components/commonComponents/BaseProfile";
import EditNote from "../notes/Edit";
import CreateNote from "../notes/Create";
import CreateToken from "./tokens/Create";
import EditToken from "./tokens/Edit";
import BaseBreadcrumb from "../../components/commonComponents/BaseBreadcrumb";
import DocumentEdit from "../documents/Edit";

export default {
  components: {
    DocumentEdit,
    BaseTableIncludable,
    BaseProfile,
    CreateNote,
    EditNote,
    CreateToken,
    EditToken,
    BaseBreadcrumb,
  },
  data() {
    return {
      page: {
        title: this.$store.getters.translate("employees"),
        name: "employees",
        model: "employee",
      },
      record: {
        custom_fields: {}
      },
      key: 0,
      loading: false,
      tab: 0,
      reset_password_loading: false,
      reset_delete_user_loading: false,
      user_id: null,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$http
        .get(this.$store.getters.appUrl + "v2/" + this.page.name + "/" + this.$route.params.id)
        .then((response) => {
          this.record = response.data;
          if (this.record.custom_fields == null || Array.isArray(this.record.custom_fields) || typeof this.record.custom_fields != "object") {
            this.record.custom_fields = {};
          }
          this.updateIncludableTables();
          this.loading = false;
        })
        .catch((error) => {
          this.$toasted.error(error);
          this.loading = false;
        });
    },
    updateIncludableTables() {
      if(this.record.person && this.record.person.user) {
        this.user_id = this.record.person.user.id;
        this.$refs.roles_table.records = this.record.person.user.roles;
        this.$refs.tokens_table.records = this.filterToken(this.record.person.user.tokens);
        this.$refs.roles_table.selected = [];
        this.$refs.tokens_table.selected = [];
      }
      this.$refs.notes_table.records = this.record.notes;
      this.$refs.notes_table.selected = [];
      this.$refs.footer_panel.record = this.record;
      this.$refs.footer_panel.load();
    },
    save() {
      if(!this.loading) {
        this.loading = true;
        this.$http
            .patch(this.$store.getters.appUrl + "v2/" + this.page.name + "/" + this.record.id, this.record)
            .then((response) => {
              this.loading = false;
              if (response.status == 200) {
                this.$toasted.success(this.$store.getters.translate("success"));
                this.load();
              } else {
                var errorMessage = response.data.message;
                var errors = Object.keys(response.data.message);
                this.$toasted.error([errorMessage[errors[0]]]);
              }
            })
            .catch((error) => {
              this.$toasted.error(error);
              this.loading = false;
            });
      }
    },
    archive() {
      this.$confirm(this.$store.getters.translate("are_you_sure")).then((res) => {
        if (res) {
          this.loading = true;
          this.$http
            .delete(this.$store.getters.appUrl + "v2/" + this.page.name + "/" + this.record.id)
            .then(() => {
              this.$router.push("/" + this.page.name);
              this.loading = false;
              this.$toasted.success(this.$store.getters.translate("success"));
            })
            .catch((error) => {
              this.$toasted.error(error);
              this.loading = false;
            });
        }
      });
    },
    resetPassword() {
      this.reset_password_loading = true;
      if (this.record.person && this.record.person.user) {
        this.$http
          .post(this.$store.getters.appUrl + "v2/resetpassword", {
            email: this.record.person.user.email,
          })
          .then(() => {
            this.reset_password_loading = false;
            this.$toasted.success(this.$store.getters.translate("password_reset_requested"));
            this.$emit("refresh");
          })
          .catch((error) => {
            this.$toasted.error(error);
            this.reset_password_loading = false;
          });
      } else {
        this.$toasted.error(this.$store.getters.translate("no_user"));
      }
    },
    deleteUser() {
      this.$confirm(this.$store.getters.translate("are_you_sure")).then((res) => {
            if (res) {
              this.reset_delete_user_loading = true;
              this.record.person.delete_user = true;
              this.$http
                .patch(this.$store.getters.appUrl + "v2/people/" + this.record.person.id, this.record.person)
                .then(() => {
                  this.reset_delete_user_loading = false;
                  this.load();
                })
                .catch(function (error) {
                  console.log(error);
                });
            }
      });
    },
    editNote(item) {
      this.$refs.edit_note.openModal('edit_note');
      this.$refs.edit_note.load(item.id);
    },
    createNote() {
      this.$refs.create_note.openModal('create_note');
    },
    createToken() {
      this.$refs.create_token.openModal('create_token');
      this.$refs.create_token.user_id = this.record.person.user.id;
      this.$refs.create_token.load();
    },
    editToken(item) {
      this.$refs.edit_token.openModal('edit_token');
      this.$refs.edit_token.load(item);
    },
    editRole(item) {
      this.$router.push("/roles/" + item.id);
    },
    preview(file) {
      this.$refs.document_edit.openModal('document_edit');
      this.$refs.document_edit.load(file);
    },
    filterToken(tokens) {
      return tokens.filter((token) => token.name != "access_token");
    },
  },
  computed: {
    getEmailaddress() {
      if (this.record.person.emailaddresses.length > 0) {
        return this.record.person.emailaddresses[0].emailaddress;
      }
      return null;
    },
    panel: {
      set(value) {
        let payload = {
          module_name: this.page.name,
          value: value,
        };
        this.$store.dispatch("setPanel", payload);
      },
      get() {
        return this.$store.getters.getPanel(this.page.name);
      },
    },
  },
};
</script>
